export const BOOKING_ID_TAB = 'booking-tabs';
export const BOOKING = 'booking';
export const FLIGHTS = 'Flights';
export const STAYS = 'Stays';
export const CARS = 'Cars';
export const VACATIONS = 'Vacations';
export const CRUISES = 'Cruises';
export const DELTA_AMEX_CARD = 'Delta AMEX Cards';
export const GIFT_CARDS = 'Gift Cards';
export const UPDATE_BAGGAGE_TRAVEL_FEES = 'Update Bags Travel Fees';
export const ALT_TEXT =
  'This link opens another site in a new window that may not follow the same accessibility policies as Delta Air Lines.';
export const GIFT_CARD_LINK = '/us/en/gift-cards/overview?icid=HPBelband';
export const UPDATE_BAGGAGE_TRAVEL_FEES_LINK = '/us/en/baggage/overview';
export const DELTA_AMEX_CARD_LINK =
  'https://apply.americanexpress.com/en-us/delta-bau-jul25/page/8/?device_type=';
export const CRUISES_LINK =
  'https://cruises.delta.com/?utm_meditum=partner_site_hp_sw&utm_source=dl-delta.com&utm_campaign=20240701-dl-sw&utm_content=cruises_hp';
